export const PLACEHOLDER_CHATGPT = "Aguardando dados do cliente";
export const PLACEHOLDER_DATABRICKS = "Aguardando dados do cliente";
export const LOAD_PLACEHOLDER = "Tudo bem, conversaremos agora sobre o cliente: ";
